import React from "react";
import Image from "next/image";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material";

const UseCasesTitle: React.FC<{ image: string; name: string }> = ({
  image,
  name,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        /**
         * gridArea is added here as this is used inside @UseCasesListItem
         * where grid is used
         * */
        gridArea: "title",
        display: "flex",
        alignItems: "center",
        columnGap: 2,
        [theme.breakpoints.down("md")]: {
          justifyContent: "center",
        },
      }}
    >
      <Image src={image} alt={name} width={28} height={28} />
      <Typography variant="h4">Use Cases for {name}</Typography>
    </Box>
  );
};

export default UseCasesTitle;
